var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconChevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M2.70703 6.50058C2.70699 6.35813 2.73504 6.21706 2.78957 6.08547C2.84411 5.95387 2.92405 5.83433 3.02484 5.73369L8.4389 0.31777C8.64229 0.114305 8.91816 -4.2877e-09 9.2058 0C9.49345 4.2877e-09 9.76931 0.114305 9.9727 0.31777C10.1761 0.521235 10.2904 0.797192 10.2904 1.08493C10.2904 1.37268 10.1761 1.64863 9.9727 1.8521L5.32581 6.50058L9.97108 11.1474C10.1745 11.3509 10.2889 11.6269 10.2889 11.9147C10.289 12.2025 10.1747 12.4785 9.97135 12.682C9.76795 12.8856 9.49206 12.9999 9.20437 13C8.91667 13.0001 8.64074 12.8858 8.43728 12.6823L3.02321 7.26639C2.82053 7.06313 2.70681 6.78768 2.70703 6.50058Z",
    fill: "#525254"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e9168ffb747b133869c92aa76d3001f0.svg";
export { ForwardRef as ReactComponent };